module.exports = __webpack_public_path__ + "img/image11.ae25a3be.png";